import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LogoFW from '../components/LogoFW';
import gstyle from '../style/style.scss';

function RegisterPage() {
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    fetch('/api/v1/register').then(async (r) => {
      const data = await r.json();
      setMessage(data.message);
      if (r.ok) {
        setMessage(data.message);
        setTimeout(() => {
          console.log('redirect /');
          navigate('/');
        }, 5000);
      } else {
        setTimeout(() => {
          console.log('refresh');
          window.location.reload();
        }, 5000);
      }
    });
  }, []);

  return (
    <div className={gstyle.fwcontainer}>
      <LogoFW />
      <div className="mb-5" />
      <h1 className="display-1 text-center">Rejestruje urządzenie...</h1>
      <div className="mb-5" />
      <div>{message}</div>
    </div>
  );
}

export default RegisterPage;
